import React from 'react';
import { RouterLink, Title } from '@zmedia/bm-soccer-ui/components';

interface IProps {
    title?: string;
    renderAs?: string;
    className?: string;
    link?: string;
    children?: any;
}

export function TitleWrap({
    className,
    renderAs = 'h3',
    title,
    link,
    children,
}: IProps) {
    if (!title) {
        return null;
    }

    if (link) {
        return (
            <Title renderAs={renderAs} className={className}>
                <RouterLink to={link} title={title}>
                    <span>{title}</span>
                </RouterLink>
                {children}
            </Title>
        );
    }

    return (
        <Title renderAs={renderAs} className={className}>
            <span>{title}</span>
            {children}
        </Title>
    );
}

export default React.memo(TitleWrap);
